export const GetNewTaskState = Name => {
  return {
    Name,
  };
}